import API from "../config/api.js";

export const GLTransactionService = {

    getAccountsByBranch(branchCode, searchTerm = "") {
      return API.get(`/api/ledger/${branchCode}/accounts`, {
        params: {
          search: searchTerm, 
        },
      });
    },

    getAccountsByTitle(searchTerm = "") {
      return API.get(`/api/ledger/accountsByTitle`, {
        params: {
          search: searchTerm, 
        },
      });
    },

    createGLTransaction(formData) {
      return API.post("/api/ledger/addtransaction", formData);
    },

    listTransactions(params, page = 1) {
      return API.get("/api/ledger/gl-transactions", { params: { ...params, page } });
  },

}
